import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentChallenge: 1,
    running: false,
    selected: -1,
    teams: [],
    nodeIdPrefix: "%3Fnode-id%3D"
  },
  mutations: {

  },
  actions: {
    nextChallenge(context) {
      context.state.currentChallenge++
    },
    selectTeam (context, args) {
      this.selected = args
    }
  }
})